import { formatCurrency, formatNumber, getDateFormat,getTimeFormat } from "utils/utils";
import { tripDutyTypeEnum } from "utils/enumObj";
import Office from "assets/images/OfficeGrey.svg";
import Clock from "assets/images/Clock.svg";
import Calendar from "assets/images/Calendar.svg";
import Taxi from "assets/images/Taxi.png";
import WaterBottle from "assets/images/WaterBottle.svg";
import Wifi from "assets/images/Wifi.svg";
import Snack from "assets/images/Snack.svg";
import Charger from "assets/images/Charger.svg";
import NewsPaper from "assets/images/NewsPaper.svg";
import { billingTypeEnum } from "utils/enumObj";

export const bookingTime = (reservationData) => [
  {
    type: "calendar",
    img: Calendar,
    title: getDateFormat(reservationData?.scheduledTime,'weekDay'),
  },
  {
    type: "time",
    img: Clock,
    title:
    getTimeFormat(reservationData?.scheduledTime) ||
      reservationData?.tripEndTime,
  },
  {
    type: "office",
    img: Office,
    title: reservationData?.companyName,
  },
  {
    type: "booked",
    img: Taxi,
    title: reservationData?.status,
  },
];

export const facilitesProviding = [
  {
    img: Wifi,
    title: "Wi-Fi",
  },
  {
    type: "Water",
    img: WaterBottle,
    title: "Water Bottle",
  },
  {
    type: "Snack",
    img: Snack,
    title: "Snacks",
  },
  {
    title: "Charger",
    img: Charger,
  },
  {
    title: "News Paper",
    img: NewsPaper,
  },
];

export const bookingDetailsData = (reservationDetails, tripTypeDetails) => {
  const additionalDetails = [];
  const totalTripPrice = Number(reservationDetails?.Payments?.[0]?.tripPrice) +  Number(reservationDetails?.driverAllowance) + Number(reservationDetails?.nightAllowance);
  const tollCharges = reservationDetails?.Payments?.[0]?.tripPricingDetails?.breakdown?.find(item => item.chargeType === "tollCharges")?.addedCharge || 0;
  const parkingCharges = reservationDetails?.Payments?.[0]?.tripPricingDetails?.breakdown?.find(item => item.chargeType === "parkingCharge")?.addedCharge || 0;
  const garageCharges = reservationDetails?.Payments?.[0]?.tripPricingDetails?.breakdown?.find(item => item.chargeType === "garageCharge")?.addedCharge || 0;
  return [
    ...additionalDetails,
    {
      title: "Passenger Name",
      data: reservationDetails?.Employee?.name,
      isVip: reservationDetails?.isVip && reservationDetails?.isVip,
    },
    {
      title: "City",
      data: reservationDetails?.ServiceCity?.name,
    },
    {
      title: "Email ID",
      data: reservationDetails?.Employee?.email,
    },
    {
      title: "Phone. No",
      data: reservationDetails?.Employee?.phoneNumber ? `${reservationDetails?.Employee?.countryCode} ${reservationDetails?.Employee?.phoneNumber}` : "NA",
    },
    {
      title: reservationDetails?.DriverProfile && "Driver Name",
      data: `${reservationDetails?.DriverProfile?.firstName} ${reservationDetails?.DriverProfile?.lastName}`,
    },
    {
      title: reservationDetails?.DriverProfile && "Driver Phone No.",
      data: reservationDetails?.DriverProfile?.mobile || "NA",
    },
    {
      title: reservationDetails?.DriverProfile && "Vehicle No.",
      data: reservationDetails?.DriverProfile?.Vehicle?.regNumber || "NA",
    },
    {
      title: "Vehicle Category",
      data: reservationDetails?.status.toLowerCase() !== ("booked" || "cancelled")? reservationDetails?.carType : reservationDetails?.MasterCarType?.carType || "NA",
    },
    {
      title: "Duty Type",
      data: reservationDetails?.dutyTypeName,
    },
    {
      title: reservationDetails?.DriverProfile && "Special Instruction",
      data: reservationDetails?.note,
      status: reservationDetails?.status,
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" &&
        "Total km",
      data: `${formatNumber(reservationDetails?.actualDistance)}` ,
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" &&
        "Drop Time",
       data: getTimeFormat(reservationDetails?.completedAt),
    },
    {
      title: parseInt(reservationDetails?.type) === tripDutyTypeEnum.airpotTransfer && "Flight No",
      data: tripTypeDetails?.flightNo,
    },
    {
      title: "Reporting Address",
      data: reservationDetails?.sourceAddress,
    },
    {
      title: reservationDetails?.sourceLandMarkAddress &&"Landmark",
      data: reservationDetails?.sourceLandMarkAddress,
    },
    {
      title: "Drop Address",
      data: reservationDetails?.destinationAddress,
    },
    {
      title: "Billing Details",
      data: parseInt(reservationDetails?.additionalInfo?.billingType) === billingTypeEnum?.billToCreditCard ? "Bill to Credit Card" : parseInt(reservationDetails?.additionalInfo?.billingType) === billingTypeEnum?.billToCompany ? "Bill to Company" : "NA",
    },
    {
    },
    {title: "Multi-Day Trip End Date",
      data: reservationDetails?.additionalInfo?.isMultiDay ? getDateFormat(reservationDetails?.additionalInfo?.multiDay?.endDate,'weekDay') : "NA",
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" &&
        "Garage To Pickup (Km)",
      data: reservationDetails?.additionalInfo?.kilometersOut|| 0,
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" &&
        "Drop To Garage (Km)",
      data: reservationDetails?.additionalInfo?.kilometersIn|| 0,
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" &&
        "Garage Charges",
      data: `₹ ${formatCurrency(garageCharges)}`|| 0,
      textType: "textBold",
    },
    {
      title: reservationDetails?.status?.toLowerCase() === "completed" && "Interstate Tax",
      data:`₹ ${formatCurrency(reservationDetails?.interstateTaxCharges)}` || 0,
      textType: "textBold",
    },
    {
      title: !reservationDetails?.DriverProfile && "Special Instruction",
      data: reservationDetails?.note,
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" &&
        "Toll Charges",
      data: `₹ ${formatCurrency(tollCharges)}`|| 0,
      textType: "textBold",
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" &&
        "Parking Charges",
      data: `₹ ${formatCurrency(parkingCharges)}`|| 0,
      textType: "textBold",
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" &&
        "Trip Charges",
      data: `₹ ${formatCurrency(totalTripPrice)}`,
      textType: "textBold",
      inclusive: true,
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "cancelled" &&
        "Cancellation Reason",
      data: reservationDetails?.cancellationReason || "NA",
    },
  ];
};

// Fare Breakup Data
export const fareBreakupData = (tripDetails) => {
  const breakdown = tripDetails?.Payments?.[0]?.tripPricingDetails?.breakdown || [];
  const gstBreakup = breakdown.find(b => b.chargeType === 'gst')?.meta?.breakup || [];
  const cgst = gstBreakup.find(g => g.name === 'cgst');
  const sgst = gstBreakup.find(g => g.name === 'sgst');
  return [
    { label: 'Base Rate', value: tripDetails?.Payments?.[0]?.tripPricingDetails?.baseRate || 0 },
    { label: 'Base Fare', value: tripDetails?.Payments?.[0]?.tripPricingDetails?.baseFareDisplay || 0 },
    { label: 'Surcharge', value: tripDetails?.Payments?.[0]?.tripPricingDetails?.surCharge || 0 },
    { label: 'Platform Charge', value: tripDetails?.Payments?.[0]?.tripPricingDetails?.platformCharge || 0 },
    { label: 'Extra Km Charge', value: tripDetails?.extraKmCharges || tripDetails?.extraPrice || 0 },
    { label: 'Extra Hr Charge', value: tripDetails?.extraHrCharges || 0 },
    { label: 'Driver Allowance', value: breakdown.find(b => b.chargeType === 'driverAllowance')?.addedCharge || 0 },
    { label: 'Night Allowance', value: breakdown.find(b => b.chargeType === 'nightAllowance')?.addedCharge || 0 },
    { label: 'Garage Charges', value: breakdown.find(b => b.chargeType === 'garageCharge')?.addedCharge || 0 },
    { label: 'Placard Charges', value: breakdown.find(b => b.chargeType === 'placard')?.addedCharge || 0 },
    { label: 'Additional Charges', value: breakdown.find(b => b.chargeType === 'additionalCharges')?.addedCharge || 0 },
    { label: 'Waiting Time Charge', value: breakdown.find(b => b.chargeType === 'waitingTimeCharge')?.addedCharge || 0 },
    { label: 'Discount', value: breakdown.find(b => b.chargeType === 'discount')?.addedCharge || 0, isDiscount: true },
    ...(cgst ? [{ label: `CGST (${cgst.unitValue}%)`, value: cgst.totalCharge || 0 }] : []),
    ...(sgst ? [{ label: `SGST (${sgst.unitValue}%)`, value: sgst.totalCharge || 0 }] : []),
    { label: 'Toll Charges', value: breakdown.find(b => b.chargeType === 'tollCharges')?.addedCharge || 0 },
    { label: 'Parking Charges', value: breakdown.find(b => b.chargeType === 'parkingCharge')?.addedCharge || 0 },
  ].filter(item => Number(item.value) !== 0);
};

//Dialog Data
export const allotDialogMenu = [
  {
    id: "1",
    label: "Cancel Duty",
  },
];

export const allotMoreMenu = [
  {
    id: "1",
    label: "Re-Allot",
  },
  {
    id: "2",
    label: "Cancel Duty",
  },
];

